exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*\n * Переменные\n */\n.close-modal[data-v-6563e2be] {\n  width: 16px;\n  height: 16px;\n  fill: #FFF;\n}\n.close-modal[data-v-6563e2be]:hover {\n  fill: #000000;\n}\n.modal-card-body[data-v-6563e2be] {\n  word-break: break-word;\n}", ""]);

// exports
